import React, { useState } from "react";
import { OrderModel } from "../../../shared/models/order/order-item.model";
import {
    GenericActionTypes,
    InWarehouseActionTypes,
    OrderPopupActionTypes,
    ReadyForShipmentActionTypes
} from "../../../../management-pages/actions/action-types.enum";
import { ActionDialog } from "../../../../management-pages/actions/dialogs/action-dialog";
import { BarekamToolPanel } from "./barekam-tool-panel";
import { WarehouseWorkerToolPanel } from "./warehouse-worker-tool-panel";
import { CustomerFilterModel } from "./filter/customer-filter";

export const ToolPanel = ({ selectedOrders, isWarehouseWorker, isAdmin, orderStateId, exportableOrders, inCustomerOrdersPage }: ToolPanelProps) => {
    const [activeAction, setActiveAction] = useState<GenericActionTypes | InWarehouseActionTypes | ReadyForShipmentActionTypes | OrderPopupActionTypes>();

    return (
        <>
            {(isWarehouseWorker || inCustomerOrdersPage) && <WarehouseWorkerToolPanel setActiveAction={setActiveAction} selectedOrders={selectedOrders} orderStateId={orderStateId} exportableOrders={exportableOrders} inCustomerOrdersPage={inCustomerOrdersPage} />}
            {!isWarehouseWorker && !isAdmin && <BarekamToolPanel setActiveAction={setActiveAction} selectedOrders={selectedOrders} />}

            <ActionDialog open={!!activeAction}
                closePopup={() => setActiveAction(undefined)}
                action={activeAction}
                orderStateId={orderStateId}
                predefinedOrders={selectedOrders ? Array.from(selectedOrders.values()) : []} />
        </>
    )
}

export interface ToolPanelProps {
    selectedOrders?: Map<number, OrderModel>,
    isAdmin?: boolean | undefined,
    isWarehouseWorker?: boolean | undefined,
    orderStateId?: string | number,
    setActiveAction?: React.Dispatch<React.SetStateAction<GenericActionTypes | InWarehouseActionTypes | ReadyForShipmentActionTypes | OrderPopupActionTypes | undefined>>,
    onFilterChanged?: (filter: CustomerFilterModel) => void,
    exportableOrders?: OrderModel[],
    inCustomerOrdersPage?: boolean;
}
